define('lib/audio/audio-default-countries-call-me',['require','lodash'],function (require) {
    var _ = require('lodash');

    return function (defaultCountries, allowedCountries) {
        var allowedDefaults = _.intersection(defaultCountries, allowedCountries);

        if (allowedDefaults.length > 0) {
            return allowedDefaults;
        }

        return allowedCountries;
    };
});

